import * as React from 'react';
import DropdownButton, { Props as DropdownButtonProps } from './DropdownButton';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';
import Placement from '../Placement/Placement';
import PlacementManager from '../Placement/PlacementManager';
import PlacementReference from '../Placement/PlacementReference';
import Text from '../Text/Text';

const { useState } = React;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DropdownValue = any;

export interface Props extends DropdownButtonProps {
  /** Handler for the value that is selected */
  onChange?: (value: DropdownValue) => void;
  /** Array of options that can be selected */
  options: {
    text: string;
    value: DropdownValue;
  }[];
  /** Selected value from the options */
  selected?: DropdownValue;
  maxHeight?: string;
}

/**
 * A quick Dropdown component for the most simplest
 * dropdown menu use case. Anything more complicated
 * and custom should be done with Placement.
 */
const Dropdown: React.FunctionComponent<Props> = (props: Props) => {
  const { children, options, onChange, selected, maxHeight, ...rest } = props;
  const [visible, setVisible ] = useState(false);

  const handleToggleVisible = () => setVisible(!visible);

  const handleChange = (value: DropdownValue) => {
    onChange && onChange(value);
    handleToggleVisible();
  };

  return (
    <PlacementManager>
      <PlacementReference>
        { ({ ref }) => (
          <DropdownButton { ...rest }
              alignChildrenHorizontal="start"
              innerRef={ ref }
              onClick={ handleToggleVisible }>
            <Text ellipsis>
              { children }
            </Text>
          </DropdownButton>
        ) }
      </PlacementReference>

      <Placement onClose={ handleToggleVisible } visible={ visible }>
        { ({ width }) => (
          <DropdownMenu maxHeight={ maxHeight } width={ width }>
            { options.map(({ text, value }) => (
              <DropdownMenuItem
                  key={ text }
                  onClick={ () => handleChange(value) }
                  selected={ selected === value }>
                { text }
              </DropdownMenuItem>
            )) }
          </DropdownMenu>
        ) }
      </Placement>
    </PlacementManager>
  );
};

export default Dropdown;
